module.exports = __webpack_public_path__ + "static/media/land-scape-img.69b1afbe.jpg";